const SessionData = {
  apellidoPaterno: '',
  apellidoMaterno: '',
  correo: '',
  curp: '',
  nombre: '',
  telefono: '',
};

export default { SessionData };
